<script lang="ts">
  import {
    Collapsible,
    type CollapsibleContentProps,
  } from "#lib/internal/components/collapsible/index"
  import { cn } from "#lib/utils"

  type $$Props = CollapsibleContentProps

  let className: $$Props["class"] = undefined
  export { className as class }
  export let transition: $$Props["transition"] = true
</script>

<Collapsible.Content
  class={cn("overflow-hidden text-sm", className)}
  {...$$restProps}
  {transition}
>
  <slot />
</Collapsible.Content>
